export const LOCALE_IDS = [
  'en-US',
  'en-GB',
  'es-ES',
  'es-MX',
  'fr-FR',
  'de-DE',
  'it-IT',
  'pt-BR',
  'hi-IN',
  'id-ID',
  'ja-JP',
  'zh-CN',
] as const;

export type LocaleId = (typeof LOCALE_IDS)[number];

export interface LocaleOption {
  id: LocaleId;
  nativeName: string;
  englishName: string;
  /** Short mark shown in the language row. */
  mark: string;
}

export const LOCALES: readonly LocaleOption[] = [
  { id: 'en-US', nativeName: 'English (United States)', englishName: 'English (United States)', mark: 'EN' },
  { id: 'en-GB', nativeName: 'English (United Kingdom)', englishName: 'English (United Kingdom)', mark: 'EN' },
  { id: 'es-ES', nativeName: 'Español (España)', englishName: 'Spanish (Spain)', mark: 'ES' },
  { id: 'es-MX', nativeName: 'Español (México)', englishName: 'Spanish (Mexico)', mark: 'ES' },
  { id: 'fr-FR', nativeName: 'Français (France)', englishName: 'French (France)', mark: 'FR' },
  { id: 'de-DE', nativeName: 'Deutsch (Deutschland)', englishName: 'German (Germany)', mark: 'DE' },
  { id: 'it-IT', nativeName: 'Italiano (Italia)', englishName: 'Italian (Italy)', mark: 'IT' },
  { id: 'pt-BR', nativeName: 'Português (Brasil)', englishName: 'Portuguese (Brazil)', mark: 'PT' },
  { id: 'hi-IN', nativeName: 'हिन्दी (भारत)', englishName: 'Hindi (India)', mark: 'हि' },
  { id: 'id-ID', nativeName: 'Bahasa Indonesia', englishName: 'Indonesian', mark: 'ID' },
  { id: 'ja-JP', nativeName: '日本語', englishName: 'Japanese', mark: 'あ' },
  { id: 'zh-CN', nativeName: '中文（简体）', englishName: 'Chinese (Simplified)', mark: '文' },
];

const LOCALE_SET = new Set<string>(LOCALE_IDS);

export function isLocaleId(value: string): value is LocaleId {
  return LOCALE_SET.has(value);
}

export function localeOption(id: LocaleId): LocaleOption {
  const found = LOCALES.find((item) => item.id === id);
  return found ?? LOCALES[0];
}
